<template>
  <div class="mx-2">
    <template v-for="(kegiatan, id) in kegiatans">
      <v-row :key="id">
        <v-col v-if="id !== 0" cols="12" class="py-0">
          <v-divider class="mt-2" />
        </v-col>
        <v-col cols="12" lg="5">
          <v-list-item class="px-0">
            <v-list-item-avatar color="blue">
              <v-icon dark>mdi-google-classroom</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0 px-1">
              <div class="caption grey--text mb-0">Nama Kegiatan</div>
              <div class="black--text body-2">
                {{ kegiatan[0] || '-' }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" lg="2">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <div class="caption grey--text mb-0">Periode Pelaksanaan</div>
              <div class="black--text body-2">
                {{ kegiatan[1] || '-' }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" lg="2">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <div class="caption grey--text mb-0">Status</div>
              <div>
                <v-chip
                  dark
                  :color="
                    Number(laporans[kegiatan[6]] && laporans[kegiatan[6]]['is_lengkap']) === 1
                      ? Number(laporans[kegiatan[6]] && laporans[kegiatan[6]]['is_terlaksana']) !== 1
                        ? 'grey'
                        : 'success'
                      : 'orange'
                  "
                >
                  {{
                    Number(laporans[kegiatan[6]] && laporans[kegiatan[6]]['is_lengkap']) === 1
                      ? Number(laporans[kegiatan[6]] && laporans[kegiatan[6]]['is_terlaksana']) !== 1
                        ? 'Tidak Memfasilitasi'
                        : 'Sudah Lengkap'
                      : 'Belum Lengkap'
                  }}
                </v-chip>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" lg="2">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <div class="caption grey--text mb-0">Aksi</div>
              <div>
                <v-btn
                  :disabled="
                    !laporans[kegiatan[6]] || Number($getDeepObj(laporans, `${kegiatan[6]}.is_terlaksana`)) !== 1
                  "
                  small
                  color="primary"
                  @click="onDetail(kegiatan[6])"
                >
                  <v-icon left>mdi-eye</v-icon> Lihat Detail
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </template>
    <base-modal-full ref="modal" :useSave="false" :title="formulir.title">
      <component
        ref="formulir"
        :is="formulir.component"
        :initValue="formulir.init || {}"
        :kKegiatan="formulir.k_kegiatan || ''"
        :isEdit="false"
        :readOnly="true"
        :masters="masters"
        :detail="formulir.detail || {}"
        :meta="meta"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormKpPaLokakarya from '@views/gtk/lokakarya/form/KpPaLokakarya';
import DetailLokakaryaRefleksi from '@views/gtk/lokakarya/form/DetailLokakaryaRefleksi';

export default {
  name: 'DetailPendampinganKegiatan',
  components: { FormKpPaLokakarya, DetailLokakaryaRefleksi },
  props: {
    detail: {
      type: Object,
    },
  },
  data() {
    return {
      laporans: {},
      kegiatans: [],
      meta: {},
      formulir: {},
    };
  },
  created() {
    this.getMasters('lokakarya_moda_psp');
  },
  computed: {
    ...mapState('master', ['masters']),

    pspKpPaId() {
      return this.$route.params.psp_kp_pa_id || null;
    },
  },
  methods: {
    ...mapActions('lokakaryaPa', ['getDetailPendampinganLokakarya', 'getDetailPendampinganRefleksi']),
    ...mapActions('master', ['getMasters']),

    fetch() {
      const id = this.pspKpPaId;

      if (!id) return;

      this.getDetailPendampinganLokakarya({ id }).then(({ data, meta }) => {
        for (const laporan of data || []) {
          this.laporans[laporan.k_lokakarya_kegiatan_psp] = laporan;
        }
        this.meta = meta || {};
        this.kegiatans = Object.keys(this.meta.lokakarya_kegiatan || {}).map((key) => {
          let kegiatan = this.meta.lokakarya_kegiatan[key] || '';
          if (kegiatan) {
            kegiatan.push(key);
          }

          return kegiatan;
        });
      });
    },

    onDetail(kKegiatan) {
      let laporan = Object.assign({}, this.laporans[kKegiatan] || {});
      laporan['psp_kp_pa_lokakarya_berkases'] = this.$getDeepObj(laporan, 'psp_kp_pa_lokakarya_berkases.data') || [];
      laporan['pelapor'] =
        this.$getDeepObj(this.detail.pelapors[laporan.psp_kp_pa_id], 'psp_profil_pa.data.ptk.data.nama') || '';

      if ((this.meta.lokakarya_nyata || []).includes(+kKegiatan)) {
        this.onDetailRefleksi(kKegiatan, laporan);
        return;
      }

      this.$set(this.formulir, 'k_kegiatan', kKegiatan);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'component', 'FormKpPaLokakarya');
      this.$set(this.formulir, 'title', 'Laporan Pendampingan Kelompok');
      this.$set(this.formulir, 'detail', laporan);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', laporan);
      });
    },

    onDetailRefleksi(kKegiatan, laporan) {
      const lokakaryaId = laporan.psp_kp_pa_lokakarya_id;

      this.getDetailPendampinganRefleksi({ id: lokakaryaId }).then((data) => {
        const lokakarya = Object.assign({}, data.lokakarya, laporan);

        this.$set(this.formulir, 'title', 'Detail Laporan Refleksi Pendampingan Kelompok');
        this.$set(this.formulir, 'component', 'DetailLokakaryaRefleksi');
        this.$set(this.formulir, 'detail', Object.assign({}, data, { lokakarya }));
        this.$set(this.formulir, 'k_kegiatan', kKegiatan);

        this.$refs.modal.open();
      });
    },
  },
};
</script>

<style scoped></style>
